module.exports = __webpack_public_path__ + "img/29_15.f27a2964.png";